import { Component, ViewChild, ChangeDetectorRef } from '@angular/core';
import { AuthService } from 'app/auth/services/auth.service';
import { AuthenticationService } from 'app/shared/services/authentication-service';
import { Result } from 'app/core/models/result';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
	selector: 'app-login',
	templateUrl: 'login.component.html'
})
export class LoginComponent {
	constructor(private _authService: AuthService, private _authentication: AuthenticationService, private _router: Router) { }
	username: string;
	password: string;
	submitAttempt: boolean;
	errors: string[];
    @ViewChild('loginForm', { static: false }) loginForm: NgForm;

    ngOnInit(): void {
        var html = document.getElementsByTagName('html')[0];
        html.className = 'fixed dark';
    }

	attemptLogin(): void {
		this.submitAttempt = true;
		if (this.loginForm.valid) {
			let userValue = encodeURIComponent(this.username);
			this._authService.login({ username: userValue, password: this.password })
				.subscribe(
					response => {
						this._authentication.saveToken(response);
						this._router.navigate(['dashboard']);
					},
					error => this.errors = (<Result>error).errorList
				);
		}
	}
}
